import { ChangeDetectionStrategy, Component } from '@angular/core';

// Compound presentation: the parent owns the section boundary; children provide slots.
@Component({ selector: 'rv-section', standalone: true, template: '<ng-content select="rv-section-heading"/><ng-content/>', host: { class: 'compound-section' }, changeDetection: ChangeDetectionStrategy.OnPush })
export class SectionComponent {}
@Component({ selector: 'rv-section-heading', standalone: true, template: '<ng-content/>', host: { class: 'section-head' }, changeDetection: ChangeDetectionStrategy.OnPush })
export class SectionHeadingComponent {}
@Component({ selector: 'rv-section-body', standalone: true, template: '<ng-content/>', host: { class: 'compound-body' }, changeDetection: ChangeDetectionStrategy.OnPush })
export class SectionBodyComponent {}
export const SECTION_COMPONENTS = [SectionComponent, SectionHeadingComponent, SectionBodyComponent] as const;
